"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSuggestions = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const material_1 = require("@mui/material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const TimeSuggestionsWrapper = styled_components_1.default.div `
  margin-top: 10px;

  .suggestions-box {
    display: flex;
    justify-content: space-around;
    gap: 30px;
    overflow-x: auto;

    @media (max-width: 360px) {
      gap: 15px;
    }
  }
`;
const Title = styled_components_1.default.div `
  padding-bottom: 10px;
`;
const Suggestion = styled_components_1.default.div `
  padding: 5px 17px;
  border: 1px solid RGB(9, 42, 94);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);
  min-width: 110px;

  @media (max-width: 360px) {
    padding: 5px 10px;
  }

  &.selected {
    color: #ffffff;
    background-color: ${props => {
    const bgColor = props.theme.palette.primary.main;
    return props.styling === '#ff0000' ? '#ff4444' : bgColor;
}}!important;
  }

  &.unavailable {
    text-decoration: line-through;
    cursor: default;
  }

  .suggested-date {
    font-size: 0.8rem;
  }
`;
const ErrorAndHintWrapper = styled_components_1.default.div `
  color: #666;
  margin-top: 5px;
`;
const TimeSuggestions = (props) => {
    const { title, timezone, handleSuggestionClick, error, hint } = props;
    const [suggestions, setSuggestions] = (0, react_1.useState)(props.suggestions);
    const useSuggestion = (nextSuggestion) => {
        if (nextSuggestion.state !== 'available') {
            return;
        }
        setSuggestions(suggestions.map(suggestion => {
            if (suggestion.value === nextSuggestion.value) {
                return Object.assign(suggestion, { selected: true });
            }
            return Object.assign(suggestion, { selected: false });
        }));
        handleSuggestionClick(nextSuggestion);
    };
    const locale = i18n_js_1.default.currentLocale();
    const dateFormatter = new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : locale === 'derobinson' ? 'de' : locale, {
        timeZone: timezone,
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
    const renderSuggestions = () => suggestions.map(suggestion => {
        const suggestedTime = helpers_1.Helpers.getHourFromDate(suggestion.value, timezone);
        const suggestedDate = dateFormatter.format(new Date(suggestion.value));
        return (react_1.default.createElement(Suggestion, { key: (0, react_uid_1.uid)(suggestion.value), onClick: () => useSuggestion(suggestion), className: suggestion.selected ? `selected ${suggestion.state}` : `${suggestion.state}` },
            react_1.default.createElement("span", { className: "suggested-date" }, suggestedDate),
            react_1.default.createElement("span", null, suggestedTime)));
    });
    return (react_1.default.createElement(TimeSuggestionsWrapper, null, error ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ErrorAndHintWrapper, null, error),
        hint && react_1.default.createElement(ErrorAndHintWrapper, null, hint))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Title, null, title),
        react_1.default.createElement(material_1.Box, { className: "suggestions-box" }, renderSuggestions())))));
};
exports.TimeSuggestions = TimeSuggestions;
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.TimeSuggestions);
